import * as actionTypes from './actionTypes';

export const setMatch=({ match, finishType })=>({
    type:actionTypes.SET_MATCH,
    payload:{ match, finishType }
})